import Pqp from "../../../3x1010/Pqp.js";
import MazeConst from "../MazeConst.js";
import Saver from "../saver/Saver.js";
import CellDesign from "./CellDesign.js";
import RoomDesign from "./RoomDesign.js";

export default class MazeDesign {
	constructor(initer, callback) {
		this.initer = initer;
		this.rows = initer.rows;
		this.cols = initer.cols;
		this.rooms = new Array();
		this.maze = undefined;
		this.callback = callback;
		this.prefabric = initer.prefabric;
		this.pre = true;
		if (!initer.prefabric) {
			this.prefabric = null;
			this.pre = false;
		}

	}

	init() {
		this.createGrid();
		this.createRooms();
		//this.createPaths();
	}

	isPre() {
		return this.pre;
	}


	createGrid() {
		this.maze = new Array();
		if (!this.isPre()) {
			for (let row = 0; row < this.rows; row++) {
				this.maze.push(new Array());
				for (let col = 0; col < this.cols; col++) {
					let cell = new CellDesign(row, col);
					this.maze[row].push(cell);
				}
			}
		} else {
			let a = this.prefabric.maze
			for (let row = 0; row < a.length; row++) {
				this.maze.push(new Array());
				for (let col = 0; col < a[0].length; col++) {
					let cell = new CellDesign(row, col);
					Saver.setCellDesing(a[row][col],cell)
					this.maze[row].push(cell);
				}
			}
		}

	}

	createRooms() {
		/*let rooms = this.initer.rooms;

		for (let x = 0; x < rooms.length; x++) {
			this.createSingleRoom(rooms[x]);
		}*/
		if (!this.isPre()) {
			this.iterator = 0;
			this.createNextRoom();
		} else {
			let rooms = this.prefabric.rooms;
			for (let x = 0; x < rooms.length; x++) {
				let room = new RoomDesign(rooms[x]);
				Saver.setRoomDesign(rooms[x], room, this.maze);
				this.rooms.push(room);
			}
			this.startCell = Saver.getFromMatrix(this.prefabric.startCell, this.maze);
			this.dispatch({ type: MazeDesign.EVENT_PATH_CREATED, data: { iterations: this.iterator, cols: this.cols, rows: this.rows } });
		}
	}

	createNextRoom() {
		let rooms = this.initer.rooms;
		if (this.iterator < rooms.length) {
			this.dispatch({ type: MazeDesign.EVENT_CREATING_ROOM, data: { iterations: this.iterator, cols: this.cols, rows: this.rows } });
			let roomIniter = rooms[this.iterator];
			this.createSingleRoom(roomIniter);
			this.iterator++

		} else {
			this.createPaths();
		}
	}

	createSingleRoom(roomIniter) {
		RoomDesign.setRoomIniterDimensions(roomIniter);
		roomIniter.mazew = this.cols;
		roomIniter.mazeh = this.rows;
		let room = new RoomDesign(roomIniter)

		let fuse = 0;
		let lCondExit = false;
		let placed = false;
		let minDistance = 4;
		while (!lCondExit) {
			if (this.placeRoom(room, minDistance)) {
				placed = true;
				lCondExit = true;
			} else {
				fuse++;
			}
			if (fuse % 20 === 0) {
				minDistance--;
				if (minDistance < 0) {
					minDistance = 0;
				}
			}

			if (fuse > MazeConst.FUSE_PLACE_ROOM) {
				lCondExit = true;
			}
		}
		if (placed) {
			this.rooms.push(room);
		} else {
			console.log("Can't place a room of " + room.w + "x" + room.h);
		}
		requestAnimationFrame(this.createNextRoom.bind(this));
	}

	placeRoom(room, minDistance) {
		//console.log(minDistance)
		let maxcol, maxrow
		maxrow = this.rows - room.h;
		maxcol = this.cols - room.w;
		let startRow = Pqp.rnd(maxrow);
		let startCol = Pqp.rnd(maxcol);

		let cells = new Array();
		let mods = new Array();
		let lOk = true;
		let intRow = 0
		let intCol = 0;
		for (let row = startRow; row < startRow + room.h; row++) {
			for (let col = startCol; col < startCol + room.w; col++) {
				let cell = this.getCell({ row: row, col: col });
				//if (cell.room === CellDesign.NOT_BELONG_TO_A_ROOM) {
				if (!cell.isRoom()) {
					if (this.checkDistanceFromOtherRooms(cell, minDistance)) {
						cells.push(cell);
						// Setta i muri
						let walls = []
						if (intCol < room.w - 1) {
							walls.push(CellDesign.APERTO);
						} else {
							walls.push(CellDesign.MURO);
						}
						if (intRow < room.h - 1) {
							walls.push(CellDesign.APERTO);
						} else {
							walls.push(CellDesign.MURO);
						}
						// Controlla se è eleggibile per un'uscita
						/*let lExit = false;
						if (walls.indexOf(CellDesign.MURO) >= 0) {
							lExit = true;
						}*/

						mods.push({ walls: walls })//, exit: lExit });
					} else {
						lOk = false;
						break;
					}
				} else {
					lOk = false;
					break;
				}
				intCol++;
			}
			if (!lOk) {
				break;
			}
			intCol = 0;
			intRow++

		}

		if (lOk) {
			// Applica i muri alle celle della stanza
			for (let x = 0; x < cells.length; x++) {
				let cell = cells[x];
				cell.room = room.id;
				cell.setWall(CellDesign.WALL_E, mods[x].walls[0]);
				cell.setWall(CellDesign.WALL_S, mods[x].walls[1]);
			}
			// Inizializza la stanza
			room.init(cells);
			return true;
		}
		return false;
	}

	checkDistanceFromOtherRooms(cell, minDistance) {
		let row = cell.row;
		let col = cell.col;
		for (let x = 1; x <= minDistance; x++) {
			let n = this.getCell({ row: row - x, col: col });
			let e = this.getCell({ row: row, col: col + x });
			let s = this.getCell({ row: row + x, col: col });
			let w = this.getCell({ row: row, col: col - x });

			let nw = this.getCell({ row: row - Math.floor(x / 2), col: col - Math.floor(x / 2) });
			let ne = this.getCell({ row: row - Math.floor(x / 2), col: col + Math.floor(x / 2) });
			let sw = this.getCell({ row: row + Math.floor(x / 2), col: col - Math.floor(x / 2) });
			let se = this.getCell({ row: row + Math.floor(x / 2), col: col + Math.floor(x / 2) });


			if (n) {
				//if (n.room !== CellDesign.NOT_BELONG_TO_A_ROOM) {
				if (n.isRoom()) {
					return false;
				}
			}
			if (e) {
				//if (e.room !== CellDesign.NOT_BELONG_TO_A_ROOM) {
				if (e.isRoom()) {
					return false;
				}
			}
			if (s) {
				//if (s.room !== CellDesign.NOT_BELONG_TO_A_ROOM) {
				if (s.isRoom()) {
					return false;
				}
			}

			if (w) {
				//if (w.room !== CellDesign.NOT_BELONG_TO_A_ROOM) {
				if (w.isRoom()) {
					return false;
				}
			}
			if (nw) {
				//if (nw.room !== CellDesign.NOT_BELONG_TO_A_ROOM) {
				if (nw.isRoom()) {
					return false;
				}
			}
			if (ne) {
				//if (ne.room !== CellDesign.NOT_BELONG_TO_A_ROOM) {
				if (ne.isRoom()) {
					return false;
				}
			}
			if (sw) {
				//if (sw.room !== CellDesign.NOT_BELONG_TO_A_ROOM) {
				if (sw.isRoom()) {
					return false;
				}
			}

			if (se) {
				//if (se.room !== CellDesign.NOT_BELONG_TO_A_ROOM) {
				if (se.isRoom()) {
					return false;
				}
			}
		}
		return true;
	}



	createPaths() {
		this.stack = new Array();
		let startCell = this.choseStartCell();
		startCell.start = true;
		startCell.visited = true;
		this.startCell = startCell;
		this.stack.push(startCell);
		this.dispatch({ type: MazeDesign.EVENT_CREATE_PATH_BLOCK, data: { lasts: this.stack.length, cols: this.cols, rows: this.rows } });
		this.nextIterationBlock();
	}

	nextIterationBlock() {
		let lCondExit = false;
		let fuse = 0;
		let lOkay = false;
		while (!lCondExit) {
			let cell = this.stack.pop();
			let neighbors = this.getUnvisitedNeighbors(cell);
			neighbors = Pqp.shuffle(neighbors);
			if (cell.isRoom()) {
				let room = this.getRoomById(cell.room);
				if (room.type !== MazeConst.ROOM_TYPE_HALLWAY) {
					let tmp = new Array();
					for (let x = 0; x < neighbors.length; x++) {
						//if (neighbors[x].room !== CellDesign.NOT_BELONG_TO_A_ROOM) {
						if (neighbors[x].isRoom()) {
							tmp.push(neighbors[x]);
						}
					}
					neighbors = tmp;
				}
			}

			neighbors = Pqp.shuffle(neighbors);
			if (neighbors.length > 0) {
				this.stack.push(cell);
				let chosen = neighbors[Pqp.rnd(neighbors.length - 1)];
				this.removeWallBetween(cell, chosen);
				chosen.visited = true;
				this.stack.push(chosen);
			}
			if (this.stack.length === 0) {
				lOkay = true;
				lCondExit = true;
			}
			fuse++;
			this.iterator++;
			if (fuse === MazeConst.FUSE_CREATE_PATH) {
				lCondExit = true;
			}
		}

		if (!lOkay) {
			this.dispatch({ type: MazeDesign.EVENT_CREATE_PATH_BLOCK, data: { lasts: this.stack.length, cols: this.cols, rows: this.rows } });
			requestAnimationFrame(this.nextIterationBlock.bind(this));
		} else {
			this.dispatch({ type: MazeDesign.EVENT_PATH_CREATED, data: { iterations: this.iterator, cols: this.cols, rows: this.rows } });
			//this.print();
		}
	}

	getRoomById(id) {
		for (let x = 0; x < this.rooms.length; x++) {
			if (this.rooms[x].id == id) {
				return this.rooms[x];
			}
		}
		return null;
	}

	choseStartCell() {
		let cells = this.getExternalCells();
		let fuse = 0;
		let lCondExit = false;
		let cell

		while (!lCondExit) {
			cell = cells[Pqp.rnd(cells.length - 1)];


			if (!cell.isRoom()) { //<<<< ------PQP
				lCondExit = true;
			}


			//console.log(cells)			
			//cell = cells[37];
			//cell = cells[43];
			//lCondExit = true;

			/*if (cell.col == this.cols-1){
				lCondExit = true;
			}*/

			/*if (cell.row == this.rows-1){
				lCondExit = true;
			}*/

			fuse++;
			if (fuse === MazeConst.FUSE_CHOOSE_CELL) {
				lCondExit = true;
			}
		}
		//console.log(fuse)
		return cell;
	}

	getExternalCells() {
		let ret = new Array();
		for (let row = 0; row < this.rows; row++) {
			for (let col = 0; col < this.cols; col++) {
				let cell = this.maze[row][col];
				if ((row === 0) || (col === 0) || (col === this.cols - 1) || (row === this.rows - 1)) {
					ret.push(cell)
				}
			}
		}
		return ret;
	}

	getUnvisitedNeighbors(cell) {
		let neighbors = new Array();
		let dirs = [MazeDesign.DIR_N, MazeDesign.DIR_E, MazeDesign.DIR_S, MazeDesign.DIR_W];
		for (let x = 0; x < dirs.length; x++) {
			let neighbor = this.getNearbyCell(cell, dirs[x]);
			if (neighbor) {
				if (!neighbor.visited) {
					neighbors.push(neighbor);
				}
			}
		}
		return neighbors;
	}

	removeWallBetween(start, next) {
		let posStart = this.getPosition(start);
		let posNext = this.getPosition(next);
		let hor = posNext.col - posStart.col;
		let ver = posNext.row - posStart.row;
		if (hor != 0) {
			if (hor > 0) {
				// e
				start.removeWall(MazeDesign.DIR_E);
			} else {
				// w
				next.removeWall(MazeDesign.DIR_E);
			}
		}
		if (ver != 0) {
			if (ver > 0) {
				// s
				start.removeWall(MazeDesign.DIR_S);
			} else {
				// n
				next.removeWall(MazeDesign.DIR_S);
			}
		}
	}

	getNearbyCell(cell, dir) {
		let newCell = null;
		let pos = this.getPosition(cell);
		pos = this.movePosition(pos, dir);
		newCell = this.getCell(pos);
		return newCell;
	}

	movePosition(pos, dir) {
		if (dir == MazeDesign.DIR_N) {
			pos.row -= 1;
		} else if (dir == MazeDesign.DIR_E) {
			pos.col += 1;
		} else if (dir == MazeDesign.DIR_S) {
			pos.row += 1;
		} else if (dir == MazeDesign.DIR_W) {
			pos.col -= 1;
		}
		return pos;
	}

	getPosition(cell) {
		return { row: cell.row, col: cell.col };
	}

	getCell(pos) {

		let cols = this.maze[pos.row];
		if (Pqp.isNullOrEmpty(cols)) {
			return null;
		}
		let cell = cols[pos.col];
		if (Pqp.isNullOrEmpty(cell)) {
			return null;
		}
		return cell;
	}


	print() {
		let s = "+" + Pqp.padr("", "-+", this.cols) + "\n";
		let prefix;
		for (let row = 0; row < this.rows; row++) {
			prefix = "|";
			for (let col = 0; col < this.cols; col++) {
				let cell = this.maze[row][col];
				let c
				if (cell.start) {
					c = "S";
				} else if (cell.end) {
					c = "X";
					//} else if ((cell.room !== CellDesign.NOT_BELONG_TO_A_ROOM) && cell.exit) {
				} else if ((cell.isRoom()) && cell.exit) {
					c = "E";
				} else {
					//c = cell.visited ? cell.room !== CellDesign.NOT_BELONG_TO_A_ROOM ? "R" : "0" : " ";
					c = cell.visited ? cell.isRoom() ? "R" : "0" : " ";
				}

				if (cell.hasWall(CellDesign.WALL_E)) {
					c += "|";
				} else {
					c += " "
				}
				s += col == 0 ? prefix + c : c;
			}
			s += "\n";
			prefix = "+";
			for (let col = 0; col < this.cols; col++) {
				let cell = this.maze[row][col];
				let c = ""
				if (cell.hasWall(CellDesign.WALL_S)) {
					c += "-+";
				} else {
					c += " +";
				}
				s += col == 0 ? prefix + c : c;
			}
			s += "\n";
		}
		//console.log(s)
	}

	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}

}

MazeDesign.DIR_N = "n";
MazeDesign.DIR_E = "e";
MazeDesign.DIR_S = "s";
MazeDesign.DIR_W = "w";
MazeDesign.DIR_NE = "ne";
MazeDesign.DIR_NW = "nw";
MazeDesign.DIR_SE = "se";
MazeDesign.DIR_SW = "sw";
MazeDesign.LABELS = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";



MazeDesign.EVENT_CREATING_ROOM = "eventCreatingRoom";
MazeDesign.EVENT_CREATE_PATH_BLOCK = "eventCreatePathBlock";
MazeDesign.EVENT_PATH_CREATED = "eventPathCreated";